import script from "./AlarmStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmStatus.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmStatus.vue?vue&type=style&index=0&id=1f336e49&lang=scss&scoped=true"
import "./AlarmStatus.vue?vue&type=style&index=1&id=1f336e49&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f336e49"]])

export default __exports__